import { TableCell, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { ITableHeadDTO } from 'data/dtos/components/i-table-head-dto'
import React, { Fragment } from 'react'
import TableFormatBodyContent from '../table-format-body-content'

interface ITableRowsContent {
  headCells: ITableHeadDTO[]
  data: any
}

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    minWidth: '100px',
    maxWidth: '120px !important',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))

const TableRowsContent: React.FC<ITableRowsContent> = ({ data, headCells }) => {
  const classes = useStyles()

  return (
    <>
      {headCells.map((headCell) => (
        <TableCell
          align='left'
          className={classes.text}
          key={Math.random()}
        >
          <TableFormatBodyContent
            row={data}
            data={headCell}
          />
        </TableCell>
      ))}
    </>
  )
}

export default TableRowsContent
